import { createReducer } from '@reduxjs/toolkit'

import { dashboardTableColumnsConfigWithSetHomepage } from 'configuration/tables/dashboardTable'
import { serializeColumns } from 'helpers/tables'

import { getDefaultTable } from '../../defaults'

const initialState = {
    table: getDefaultTable(
        serializeColumns(dashboardTableColumnsConfigWithSetHomepage),
        {
            sorter: {
                field: 'created_at',
                order: 'descend',
            },
        }
    ),
}

export default createReducer(initialState, () => {})
